import { ProtocolVersion } from 'entities/protocol_version'
import { Badge } from 'react-bootstrap'
import { ViewModel } from 'view_models/view_model'

export class ProtocolVersionViewModel extends ViewModel<ProtocolVersion> {
    versionColors = ['#2196F3', '#009688', '#F44336', '#FFC107', '#795548', '#673AB7', '#B71C1C', '#0D47A1', '#CDDC39', '#18FFFF', '#455A64']
    public versionView = () => {
        if (!this.object?.number) {
            return <></>
        }
        return (
            <Badge bg="none" style={{ backgroundColor: this.versionColors[(this.object.number! - 1) % this.versionColors.length], fontSize: 12 }}>
                ver.{this.object.number}
            </Badge>
        )
    }
}
